var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('s-table',{ref:"data_list",attrs:{"colDefinitions":_vm.tableCols,"modx-processor":_vm.processor,"r-query":_vm.processorQuery,"pagging":10000,"limit":10000,"lazyLoader":false,"addEmptyLine":false},on:{"cell-clicked":_vm.clickHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }